export const FORCED_SPP_BEDBANK_OFFER_IDS = new Set([
  // Hilton Surfers Paradise Hotel & Residences
  // (accommodation service property ID: `ad550432-adb0-4854-9411-92605a98538b`)
  '23ef2ddf-d81b-42fd-ba13-73750fb343f5',
  // Sheraton Grand Mirage Resort, Gold Coast
  // (accommodation service property ID: `05a93eda-7492-4539-83b1-1e5eab0f155c`)
  '14bae874-5812-46ba-9884-9602b6b8e264',
])
